module.exports = __webpack_public_path__ + "static/media/dohnal.efde8365.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/dohnal.jpg
// module id = 491
// module chunks = 0